import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';

const CompletionRequest = () => {
  return (
    <Layout>
      <div className="max-w-2xl mx-auto p-4">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h1 className="text-2xl font-bold mb-3">בקשה להשלמת פרטים</h1>
          <p className="text-gray-600 leading-7">
            כדי לשפר את ההתאמות למשרות, אפשר להשלים פרטים מקצועיים ולעדכן בחירת תפקידים בעמוד המשרות.
          </p>
          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <Link to="/profile" className="btn-primary">
              התחלת מענה
            </Link>
            <Link to="/jobs" className="btn-secondary">
              עדכון בחירת תפקידים
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CompletionRequest;
